import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentService } from '../services/payment.service';
import { DataService } from '@app/core/services/data.service';
import { dictionaryItems } from '@app/core/constants/dictionaryItems';
import { Adb2cService } from '@app/blocks/adb2c/services/adb2c/adb2c.service';
import { Subject, Subscription, takeUntil } from 'rxjs';

@Component({
    selector: 'app-payment-sub-account-breakdown',
    imports: [ CommonModule ],
    templateUrl: './payment-sub-account-breakdown.component.html',
    styleUrl: './payment-sub-account-breakdown.component.scss',
})
export class PaymentSubAccountBreakdownComponent implements OnInit, OnDestroy {

    constructor(private paymentService: PaymentService,
        private dataService: DataService,
        private adb2cService: Adb2cService,
    ) {
        this.adb2cService.getUser();
    }

    breakdown: any = {};
    breakdownVisible = false;
    offsetHeight = 0;
    viewBalanceBreakdownText = 0;
    dictionary: any;
    balanceText = "";

    private destroy$ = new Subject<void>();
    private userSubscription?: Subscription;

    ngOnInit() {

        this.breakdownVisible = false;
        this.offsetHeight = 0;
        this.viewBalanceBreakdownText = 0;

        this.dataService.getDictionaryItems()
            .subscribe({
                next: (response) => {
                    this.dictionary = response;
                    this.balanceText = this.dataService.getDictionaryItemByKeyAndLanguage(this.dictionary, dictionaryItems.viewBalanceBreakdown, "en-GB") ?? dictionaryItems.viewBalanceBreakdown;
                },
                error: (error) => {
                    console.log(error);
                }
            });


        this.userSubscription = this.adb2cService.activeUser.asObservable().pipe(takeUntil(this.destroy$)).subscribe(user => {
            if (user && user.sub && user[ 'tenancy_reference' ]) {

                this.paymentService.getSubAccountBreakdown(user[ 'tenancy_reference' ], 0).subscribe({
                    next: (response) => {
                        if (response) {
                            this.breakdown = response;

                        }
                    },
                    error: (error) => {
                        console.log(error);
                    }
                });
            }
        });
    }

    showBreakdown() {
        this.breakdownVisible = !this.breakdownVisible;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();

        this.userSubscription?.unsubscribe();
    }
}
